import React, { useState, useEffect } from "react";
import { Input, Select, DatePicker,  Spin } from "antd";
// import { DownOutlined } from "@ant-design/icons";
import JobLockingTable from "./job_locking_table/JobLockingTable";
import JobBookingTable from "./job_booking_table/JobBookingTable";
import LockingDocumentTable from "./Locking_document_modal/LockingDocumentModal";

import Api from "../../../../services/ServiceApi";
import Cookies from "js-cookie";
import moment from "moment";
import XLSX from 'xlsx';
let dataIsNotNull = false;

const JobManagement = () => {
  const [activeTab, setActiveTab] = useState(0);
  // const [isBookingModalVisible, setBookingModalVisible] = useState(false);
  const [isVisibleLockingDocument, setVisibleLockingDocument] = useState(false);
  const [lockedData, setLockedData] = useState({})
  const [bookedData, setBookedData] = useState([]);
  const [origiBookedData, setOrigiBookedData] = useState([]);
  const [typeDate, setTypeDate] = useState(null);
  // const [tabStatus, setTabStatus] = useState("Booking");
  const [bookingData, setBookingData] = useState([]);
  const [bookingData_original, setBookingDataOriginal] = useState([]);
  const [jobLockingData, setJobLockingData] = useState([]);
  const [jobLockingData_original, setjobLockingDataOriginal] = useState([]);
  const [TextDate, setTextDate] = useState("");
  const [loadingTable, setloadingTable] = useState(true);



  const { Option } = Select;
  const { RangePicker } = DatePicker;

  const tab = [{ text: "Booking" }, { text: "Locking" }];
  const searchDetail = (value) => {
    var original = activeTab === 0 ? bookingData_original : jobLockingData_original;
    let tempFilteredData = (activeTab === 0 ? bookingData_original : jobLockingData_original).filter((o) =>
      Object.keys(o).some((k) =>
        String(o[k]).toLowerCase().includes(value.toLowerCase())
      )
    );
    console.log();
    if (activeTab === 0) {
      if (value === "") {
        setBookingData(original);
      } else {
        setBookingData(tempFilteredData);
      }
    }
    else {
      if (value === "") {
        var temp = [] ;
        for (let i = 0; i < original.length ; i++ ){
            temp.push({...original[i], row_key: i})
        }
        setJobLockingData(temp);
      } else {
        var temp = [] ;
        for (let i = 0; i < tempFilteredData.length ; i++ ){
            temp.push({...tempFilteredData[i], row_key: i})
        }
        setJobLockingData(temp);
      }
    }

  }

  const converDate = (item) => {
    if (item === null) {
      return moment(new Date()).format("YYYY-MM-DD")
    }
    else {
      if (moment(item, "DD/MM/YYYY").format("YYYY-MM-DD") === "Invalid date") {
        return moment(item).format("YYYY-MM-DD")
      }
      else {
        return moment(item, "DD/MM/YYYY").format("YYYY-MM-DD")
      }
    }


  }

  const FilterDate = (value) => {

    if (value != null) {
      var original = activeTab === 0 ? bookingData_original : jobLockingData_original;

      const filteredItemsNotnull = original.filter((data) => data.booking_external_date !== null || data.booking_internal_date_end !== null);
      const filteredItems = filteredItemsNotnull.filter((item, index) =>
        TextDate === "external" ?
          (moment(converDate(item.booking_external_date)).isBetween(converDate(value[0]),
            moment(converDate(value[1])).add(1, 'days')) === true)

          :
          (moment(converDate(item.booking_internal_date)).isBetween(converDate(value[0]),
            moment(converDate(value[1])).add(1, 'days')) === true)
      );
      if (activeTab === 0) {
        if (value === "") {
          setBookingData(original);
        } else {
          setBookingData(filteredItems);
        }
      }
      else {
        if (value === "") {
          setJobLockingData(original);
        } else {
          setJobLockingData(filteredItems);
        }
      }
    }
  }

  useEffect(() => {
   parseInt(Cookies.get("JobMgmtTab"))?   setTab(parseInt(Cookies.get("JobMgmtTab")))  : setTab(0)
  }, {});

  // useEffect(() => {
  //   setBookingData(bookingData)
  // }, { bookingData });

  // useEffect(() => {
  //   Api.post("v2/getListBooking", {
  //     "customer": null
  //     , "type_date": null
  //     , "start_date": null
  //     , "end_date": null
  //     , "where_cond": null
  //   })
  //     .then((res) => {
  //       if(res.data.result.code.toLowerCase() == "p"){
  //         let bus_booking_list = res.data.data.bus_booking_list
  //         for (let i = 0; i < bus_booking_list.length; i++) {
  //           if (bus_booking_list[i].booking_internal_date !== null) {
  //             bus_booking_list[i].booking_internal_date = moment(bus_booking_list[i].booking_internal_date).format('DD/MM/YYYY')
  
  //           }
  //           if (bus_booking_list[i].booking_external_date !== null) {
  //             bus_booking_list[i].booking_external_date = moment(bus_booking_list[i].booking_external_date).format('DD/MM/YYYY')
  
  //           }
  //         }
  //         setBookingData(res.data.data.bus_booking_list);
  //         setBookingDataOriginal(res.data.data.bus_booking_list);
  //       }
  //     })
  //     .catch((e) => {
  //       console.log(e);
  //     });
  // }, []);

  // useEffect(() => {
  //   Api.post("v3/getListLocking", {
  //     "param_text": "",
  //     "where_cond": ""
  //   }).then((res) => {
  //     // console.log(res.data.data.list_bus_locking_list);
  //     if(res.data.result.code.toLowerCase() == "p"){
  //       // console.log("list locking", res.data.data.list_bus_locking_list);
  //       for (let i = 0; i < res.data.data.length; i++) {
  //         res.data.data.list_bus_locking_list[i]["row_key"] = i;
  //       }
  //       setJobLockingData(res.data.data.list_bus_locking_list);
  //       setjobLockingDataOriginal(res.data.data.list_bus_locking_list);
  //     }
  //   });

  // }, []);

  // useEffect(() => {
  //   setJobLockingData()
  // }, { jobLockingData });



  const onDatePicker = (val) => {
    console.log('typeDate', typeDate);
    console.log('onDatePicker', val);
    if (val !== null) {
      let mTypeDate = "external"
      let sDate = moment(val[0]).format('YYYY-MM-DD')
      let eDate = moment(val[1]).format('YYYY-MM-DD')
      if (typeDate === "internal") {
        mTypeDate = "internal"
      }

      Api.post("v2/getListBooking", {
        "customer": null
        , "type_date": typeDate
        , "start_date": sDate
        , "end_date": eDate
        , "where_cond": null
      })
        .then((res) => {
          console.log('onDatePicker getListBooking', res);
          if(res.data.result.code.toLowerCase() == "p"){
              let bus_booking_list = res.data.data.bus_booking_list
            console.log('onDatePicker bus_booking_list', bus_booking_list);

            for (let i = 0; i < bus_booking_list.length; i++) {
              if (bus_booking_list[i].booking_internal_date !== null) {
                bus_booking_list[i].booking_internal_date = moment(bus_booking_list[i].booking_internal_date).format('DD/MM/YYYY')

              }

              if (bus_booking_list[i].booking_external_date !== null) {
                bus_booking_list[i].booking_external_date = moment(bus_booking_list[i].booking_external_date).format('DD/MM/YYYY')

              }
            }
            setBookedData(res.data.data.bus_booking_list)
            // setOrigiBookedData(res.data.data.bus_booking_list)
          }
        })
        .catch((e) => {
          console.log(e);
        });
    } else {
      Api.post("v2/getListBooking", {
        "customer": null
        , "type_date": null
        , "start_date": null
        , "end_date": null
        , "where_cond": null
      })
        .then((res) => {
          console.log('getListBooking', res);
          if(res.data.result.code.toLowerCase() == "p"){

          let bus_booking_list = res.data.data.bus_booking_list
          console.log('bus_booking_list', bus_booking_list);

          for (let i = 0; i < bus_booking_list.length; i++) {
            if (bus_booking_list[i].booking_internal_date !== null) {
              bus_booking_list[i].booking_internal_date = moment(bus_booking_list[i].booking_internal_date).format('DD/MM/YYYY')

            }

            if (bus_booking_list[i].booking_external_date !== null) {
              bus_booking_list[i].booking_external_date = moment(bus_booking_list[i].booking_external_date).format('DD/MM/YYYY')

            }
          }
          setBookedData(res.data.data.bus_booking_list)
          setOrigiBookedData(res.data.data.bus_booking_list)
          }
        })
        .catch((e) => {
          console.log(e);
        });
    }
  }

  // Download data into the table depends on index (0, 1) and text  ("Booking", "Locking")...
  const setTab = async (index) => {
    Cookies.set("JobMgmtTab", index, { expires: 1 });
    setActiveTab(index)
    // setTabStatus(text)
    await  setloadingTable(true)
    if(index === 0){
       await Api.post("v2/getListBooking", {
        "customer": null
        , "type_date": null
        , "start_date": null
        , "end_date": null
        , "where_cond": null
      })
        .then((res) => {
          if(res.data.result.code.toLowerCase() == "p"){
            let bus_booking_list = res.data.data.bus_booking_list
            for (let i = 0; i < bus_booking_list.length; i++) {
              if (bus_booking_list[i].booking_internal_date !== null) {
                bus_booking_list[i].booking_internal_date = moment(bus_booking_list[i].booking_internal_date).format('DD/MM/YYYY')
    
              }
              if (bus_booking_list[i].booking_external_date !== null) {
                bus_booking_list[i].booking_external_date = moment(bus_booking_list[i].booking_external_date).format('DD/MM/YYYY')
    
              }
            }
            setBookingData(res.data.data.bus_booking_list);
            setBookingDataOriginal(res.data.data.bus_booking_list);
          }
        })


    } else if  (index === 1){
      await Api.post("v3/getListLocking", {
        "param_text": "",
        "where_cond": ""
      }).then((res) => {
        // console.log(res.data.data.list_bus_locking_list);
        if(res.data.result.code.toLowerCase() == "p"){
          var temp = [];
          // console.log("list locking", res.data.data.list_bus_locking_list);
          for (let i = 0; i < res.data.data.list_bus_locking_list.length; i++) {
            temp.push({...res.data.data.list_bus_locking_list[i], row_key: i})
          }
          // console.log(temp);
          setJobLockingData(temp);
          setjobLockingDataOriginal(temp);
        }
      });
    }
    await  setloadingTable(false)
  }

  const ExportExcel = () => {
    var result_array = [];
    var setHerder = {};
    const wb = XLSX.utils.book_new();
    var dataSet =  activeTab === 0 ? {bookingData: bookingData}  :  {jobLockingData: jobLockingData}  ; 
    console.log(dataSet);
    for (const [key, value] of Object.entries(dataSet)) {
      // console.log(`${key}: ${value}`);
      for (let i = 0; i < dataSet[`${key}`].length; i++) {
        for (const [key_h, value_h] of Object.entries(dataSet[`${key}`][i])) {
          setHerder[`${key_h}`] = `${key_h}`;
        }
        result_array.push(dataSet[`${key}`][i])
      }
      let binaryWS = XLSX.utils.json_to_sheet([setHerder, ...result_array], { skipHeader: true });
      XLSX.utils.book_append_sheet(wb, binaryWS, `${key}`);
      result_array = [];
      setHerder = {};
    }
    XLSX.writeFile(wb, activeTab === 0 ? "BookingData.xlsx" : "LookingData.xlsx");

  }

  return (
    <div className="container-fluid">
      <div className="d-flex align-items-center justify-content-between row my-2">
        <div className="col-8">
          <div className="d-flex">
            <div className="mr-4">
              <Input.Group compact>
                {/* Search */}
                <Input.Search
                  placeholder="Search"
                  onSearch={(value) => searchDetail(value)}
                  style={{ width: "250px", "margin-right": "1rem" }}
                  enterButton
                />
                {/* Ads area dropdown */}
                <Select
                  placeholder="External"
                  // value="External date"
                  style={{ width: "140px" }}
                  onChange={(val) => {
                    setTextDate(val);
                  }}
                // mode="multiple"
                // allowClear
                >
                  <Option
                    key={`dateType_1`}
                    value="external"
                  >
                    External
                  </Option>
                  <Option
                    key={`dateType_2`}
                    value="internal"
                  >
                    Internal
                  </Option>
                </Select>
                {/* Range date */}
                <RangePicker
                  onChange={(val) => {
                    FilterDate(val);
                  }}
                  // onChange={onDatePicker(val)}
                  allowClear
                  style={{
                    marginLeft: "10px ",
                    color: "#000F9F",
                    marginRight: "20px",
                  }}
                />
                <div>
                </div>
              </Input.Group>
            </div>
          </div>
          <div className="d-flex">
            <Input.Group compact></Input.Group>
          </div>
        </div>
        <div className="col-4" style={{textAlign : "right"}}>
          <button className="btn btn-warning mt-3 ml-2" onClick={() => ExportExcel()}>Export Data</button>
        </div>
      </div>



      <div className="card-table-ma">
        {/* <ul className="nav">
                                {tab.map((item, index) => <li key={index} className="nav-item fs-12 font-mont-sb mr-1">
                                    <a className={active === index ? "nav-link active" : "nav-link"} onClick={() => this.setState({ active: index })}>{item.text}</a>
                                </li>)}
                            </ul> */}
        <div style={{ padding: "20px" }}>
          <ul className="nav">
            {tab.map((item, index) => (
              <li key={index} className="nav-item fs-14 font-mont-sb mr-1">
                <a
                  className={
                    activeTab === index ? "nav-link active" : "nav-link"
                  }
                  onClick={() => setTab(index, item.text)}
                >
                  {item.text}
                </a>
              </li>
            ))}
          </ul>
          {activeTab === 1 && parseInt(localStorage.getItem("permission"))  === 1  ?
            lockedData.length > 0 ?
              <button className="btn btn-warning mt-3 ml-2" onClick={() => setVisibleLockingDocument(true)}>Add Job ({lockedData.length})</button>
              : null
            : ""}
          {isVisibleLockingDocument ? (
            <LockingDocumentTable handleVisible={setVisibleLockingDocument} lockedData={lockedData} />
          ) : null}
          <Spin spinning={loadingTable}>
          {activeTab === 0 ? <JobBookingTable /*tabStatus={tabStatus}*/ bookingData={bookingData} /> : null}
          {activeTab === 1 ? <JobLockingTable /*tabStatus={tabStatus}*/ setLockedData={setLockedData} jobLockingData={jobLockingData} /> : null}
          </Spin>
        </div>
      </div>
    </div>
  );
};

export default JobManagement;
